export const MY_PROFILE = 'MY_PROFILE';
export const MY_PROFILE_SUCCESS = 'MY_PROFILE_SUCCESS';
export const MY_PROFILE_ERROR = 'MY_PROFILE_ERROR';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';
export const IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS';
export const IMAGE_DELETE_SUCCESS = 'IMAGE_DELETE_SUCCESS';
